import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import successimg from "../../../assets/images/successimg.png";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
const CreateSeason = ({
  successPopUp,
  toggleSuccessDialog,
  msg,
  handleSubmit,
}) => {
  const [radioValue, setRadioValue] = useState("");
  const [seasonList, setSeasonList] = useState([]);
  const [isNewSeason, setIsNewSeason] = useState(false);
  const [isCurrentSeason, setisCurrentSeason] = useState(true);
  const data = useSelector((state) => state.loggedInUser);
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.userProfile?.currentSeason?.years
  );
  const [upComingSeason, setUpComingSeason] = useState(null);
  const currentYear = new Date().getFullYear();
  const schoolId = getFromLocalStorage("schoolId");

  useEffect(() => {
    getAllSeasonList();
    if (currentSeason) {
      setUpComingSeason(Number(currentSeason.substring(0, 4)));
    }
  }, [currentSeason]);

  const handleRadioClick = (e, data, isNew) => {
    setIsNewSeason(isNew);
    setRadioValue(data);
  };

  const isRadioSelected1 = (value) => {
    return value === radioValue;
  };

  const getAllSeasonList = () => {
    userService
      .getCurrentSeason(schoolId)
      .then((res) => {
        setSeasonList(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={successPopUp}
      onClose={toggleSuccessDialog}
    >
      <DialogTitle>
        <div className="d-flex justify-sp-btn brd-bottom">
          <p className="fs-20 semi-bold">Create a new season</p>
          <FaTimes
            onClick={(event) => {
              event.stopPropagation();
              toggleSuccessDialog(false);
            }}
            className="crossview cp"
          />
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-direction-c">
          <p className="fs-18 semi-bold">
            Create a season to start building your schedule
          </p>
          <div>
            <div className="d-flex align-cent mg-top-10 season-container">
              <div className="d-flex-align-cent">
                <input
                  type="radio"
                  value={`${
                    upComingSeason ? upComingSeason + 1 : currentYear
                  } - ${upComingSeason ? upComingSeason + 2 : currentYear + 1}`}
                  className="mg-right-10"
                  checked={isRadioSelected1(
                    `${upComingSeason ? upComingSeason + 1 : currentYear} - ${
                      upComingSeason ? upComingSeason + 2 : currentYear + 1
                    }`
                  )}
                  onChange={(e) => handleRadioClick(e, e.target.value, true)}
                />
                <p className="fs-18 semi-bold mg-left-10">
                  {`${upComingSeason ? upComingSeason + 1 : currentYear} - ${
                    upComingSeason ? upComingSeason + 2 : currentYear + 1
                  }`}
                </p>
              </div>
            </div>
          </div>
          <div className="mg-top-20 d-flex-align-cent season-container">
            <input type="checkbox" checked />
            <p className="semi-bold mg-left-10">Start The New Season</p>
            <p className="redstar fs-20">*</p>
          </div>
          <div className="mg-top-5 d-flex-align-cent season-container">
            <input type="checkbox" checked />
            <p className="semi-bold mg-left-10">Archive The Previous Season</p>
            <p className="redstar fs-20">*</p>
          </div>
          <div className="col-12 col-md-12 col-lg-12 ml-auto text-center mg-top-20">
            <button
              type="button"
              className="rectangle-btn bg-grey white mr-2"
              onClick={() => toggleSuccessDialog()}
            >
              Cancel
            </button>

            <button
              type="submit"
              className={
                radioValue
                  ? "rectangle-btn bg-navyBlue white"
                  : "rectangle-btn bg-navyBlue white inactive"
              }
              disabled={!radioValue}
              onClick={() =>
                handleSubmit(
                  radioValue,
                  isCurrentSeason,
                  getAllSeasonList,
                  setRadioValue
                )
              }
            >
              Save Season
            </button>
          </div>
        </div>

        <div className="clear10"></div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateSeason;
